export const  ReportTableCol ={

    //Methods
    formatGroupName: (obj)=>{
        return "TEST"
    },

    formatStatus : (status)=>{
      if(status == "Not Completed"){
        return "NC";
      }
    },


    //Config
    taskReportTable : [
        {
          id: "id",
          name: "ID",
          selector: (row) => row.id,
          grow: 0.5,
        },
        {
          name: "NAME",
          selector: (row) => row.name,
          grow: 2,
        },
        {
          name: "DEPARTMENT",
          selector: (props) =>{ if(props.groups) {return props.groups[0].name;} },
        },
        {
            name : "TYPE",
            selector :(props) => {if(props.tasks) {return props.tasks[0].type}}
        },
        {
          name: "STATUS",
          selector: (props) => {
            if(props.tasks) { 
              if(props.tasks[0].status == "Not Completed"){
                let elem = <input type='button' className='btn btn-warning' value='PENDING'/>;
                return elem;
              }else if(props.tasks[0].status == "Completed"){
                let elem = <input type='button' className='btn btn-success' value='COMPLETED'/>;
                return elem;
              }else if(props.tasks[0].status == "Overdue"){
                let elem = <input type='button' className='btn btn-danger' value='OVERDUE'/>;
                return elem;
              }
           }
        }}
      ],

      userReportTable : [
        {
          id: "id",
          name: "TASK ID",
          selector: (row) => row.id,
          grow: 0.5,
        },
        {
          name: "TASK TITLE",
          selector: (row) => row.name,
          grow: 2,
        },
        {
            name : "TASK TYPE",
            selector :(row) => row.type
        },
        {
          name: "STATUS",
          selector: (props) => {
            if(props.status) { 
              if(props.status == "Not Completed"){
                let elem = <input type='button' className='btn btn-warning' value='PENDING'/>;
                return elem;
              }else if(props.status == "Completed"){
                let elem = <input type='button' className='btn btn-success' value='COMPLETED'/>;
                return elem;
              }else if(props.status == "Overdue"){
                let elem = <input type='button' className='btn btn-danger' value='OVERDUE'/>;
                return elem;
              }
           }
        }}
      ],

      projectReportTable : [
        {
          id: "id",
          name: "ID",
          selector: (row) => row.id,
          grow: 0.5,
        },
        {
          name: "NAME",
          selector: (row) => row.name,
          grow: 2,
        },
        {
          name: "DEPARTMENT",
          selector: (props) =>{ if(props.groups) {return props.groups[0].name;} },
        },
        {
            name : "TYPE",
            selector :(props) => {if(props.tasks) {return props.tasks[0].type}}
        },
        {
          name: "STATUS",
          selector: (props) => {
            if(props.tasks) { 
              if(props.tasks[0].status == "Not Completed"){
                let elem = <input type='button' className='btn btn-warning' value='PENDING'/>;
                return elem;
              }else if(props.tasks[0].status == "Completed"){
                let elem = <input type='button' className='btn btn-success' value='COMPLETED'/>;
                return elem;
              }else if(props.tasks[0].status == "Overdue"){
                let elem = <input type='button' className='btn btn-danger' value='OVERDUE'/>;
                return elem;
              }
           }
        }}
      ]
}